var React = require('react');

function CheckMarkReps (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".checkmark-svg{fill:#fff;}")),React.createElement("title",{"key":1},"Artboard 16"),React.createElement("path",{"className":"checkmark-svg","d":"M26.87,3.57l5.28,5.27L11.84,29.18,0,17.31l5.26-5.25,6.56,6.56Z","key":2})]);
}

CheckMarkReps.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32.75 32.75"};

module.exports = CheckMarkReps;

CheckMarkReps.default = CheckMarkReps;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/assets/Check_Mark_Reps.svg
// module id = 167
// module chunks = 0